import { render, staticRenderFns } from "./ODM-logo.vue?vue&type=template&id=6ffff06b&scoped=true"
import script from "./ODM-logo.vue?vue&type=script&lang=js"
export * from "./ODM-logo.vue?vue&type=script&lang=js"
import style0 from "./ODM-logo.vue?vue&type=style&index=0&id=6ffff06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffff06b",
  null
  
)

export default component.exports